
import Masonry from 'masonry-layout';
import { nuAjax } from '@/utilities/ajax.js';
import { textToHTML } from '@/utilities/textToHtml';
import { get } from '@/utilities/querySelector';
import { options } from '@/global/slick-options';


class CollageGrid extends HTMLElement {
    static observedAttributes = ['gallery', 'page'];

    constructor() {
        super();
        this.content = this.querySelector( '.collage-grid__main' );
        this.pages = JSON.parse( this.getAttribute( 'gallery' ) ?? '[]' );
        if ( !Array.isArray( this.pages ) ) {
            console.warn( 'collage-grid should have an array of attachment IDs as the gallery' );
        }
        this.page = 1;
        this.max = this.pages.length;

        this.nextTrigger = this.querySelector( '[data-next]' );
        this.resetTrigger = this.querySelector( '[data-reset]' );

        if ( this.hasAttribute( 'lightbox' ) ) {
            jQuery( this.content ).slickLightbox( {
                itemSelector: '.collage-grid__item',
                src: ( item ) => get( 'img', item )?.getAttribute( 'src' ),
                slick: {
                    ...options,
                    slidesToShow: 1,
                }
            } );
        }
    }

    connectedCallback() {
        this.masonry = new Masonry( this.content, {
            columnWidth: '.collage-grid__item',
            itemSelector: '.collage-grid__item',
            stagger: 20,
            transitionDuration: '0.8s',
        } );

        this.nextTrigger?.addEventListener( 'click', this.next.bind( this ) );
        this.resetTrigger?.addEventListener( 'click', this.reset.bind( this ) );
    }

    disconnectedCallback() {

    }

    render() {
        this.masonry.refresh();
    }

    next() {
        if ( this.page === this.max ) return;
        this.page++;
        this.setAttribute( 'page', this.page.toString() );
    }

    reset() {
        this.page = 1;
        this.setAttribute( 'page', this.page.toString() );
    }

    /**
     * @param {'page'|'gallery'} name
     * @param {string} oldValue
     * @param {string} newValue
     * @return {void}
     */
    attributeChangedCallback( name, oldValue, newValue ) {
        // @ts-ignore Yes it is possible to do this
        this?.[`${name}Changed`]( oldValue, newValue );
    }


    /**
     * @async
     * @param {string|number} oldPage
     * @param {string|number} newPage
     * @returns {Promise<void>}
     */
    async pageChanged( oldPage, newPage ) {
        [oldPage, newPage] = [+oldPage, +newPage];

        if ( oldPage === newPage || ( !oldPage && newPage === 1 ) ) return;

        this.nextTrigger?.classList.add( 'loading' );
        this.resetTrigger?.classList.add( 'loading' );

        const html = await this.getPage( newPage - 1 );
        if ( !html ) return console.warn( 'Something gone wrong m8' );

        const newItems = html.querySelectorAll( '.collage-grid__item' );

        if ( newPage === 1 ) {
            this.content.innerHTML = '';
        }

        newItems.forEach( item => {
            this.content.appendChild( item );
            this.masonry.addItems( item );
        } );

        this.masonry.reloadItems();
        this.masonry.layout();

        this.setButtonStates();

        this.nextTrigger?.classList.remove( 'loading' );
        this.resetTrigger?.classList.remove( 'loading' );

        if ( newPage < oldPage ) {
            this.nextTrigger?.scrollIntoView();
        }
    }

    galleryChanged() { }

    setButtonStates() {
        if ( this.page === this.max ) {
            this.nextTrigger?.classList.add( 'hidden' );
            this.resetTrigger?.classList.remove( 'hidden' );
        } else {
            this.resetTrigger?.classList.add( 'hidden' );
            this.nextTrigger?.classList.remove( 'hidden' );
        }
    }

    /**
     * Description placeholder
     *
     * @async
     * @param {number} page
     * @returns {Promise<HTMLElement|false>}
     */
    async getPage( page ) {
        page = this.pages[page];

        const cached = sessionStorage.getItem( `collage-grid-${page}` );

        if ( cached ) {
            return textToHTML( cached );
        }

        const res = await nuAjax( 'get_attachment_images', {
            images: page,
            image_class: 'collage-grid-image relative rounded-general'
        } );

        const json = await res.json();

        if ( json.success === false ) {
            return false;
        }

        const imageHtml = json.data.map( image => {
            return `<li class="collage-grid__item theme--mid rounded-general">${image}</li>`;
        } ).join( '' );

        const images = textToHTML( '<div>' + imageHtml + '</div>' );

        sessionStorage.setItem( `collage-grid-${page}`, images.outerHTML );

        return images;
    }
}

customElements.define( 'collage-grid', CollageGrid );
